import React from "react";
import { useNavigate } from 'react-router-dom'
import Header from "../Header_/Header";
import styles from "./Hero.module.css";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import "./Hero.css";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate()
  return (
    <div className={styles.main}>
      <Header />
      <div className={styles.inner}>
        <Container className="p-0">
          <div className={styles.swiperCont}>
            <Swiper
              spaceBetween={300}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                280: {
                  slidesPerView: 1,
                },
              }}
              modules={[Pagination]}
              className="hero_swiper"
            >
              <SwiperSlide>
                <Row lg={12} className="w-100 gy-5">
                  <Col lg={7}>
                    <div className={styles.contentCont}>


                      

                      {/* OLd */}
                      {/* <h2 style={{ color: "#1d1d1d" }} className="h2_main">
                        EXPERTS in Residential Solar and Home, Cottage and
                        Out-Building Solar and Battery Solutions, Off Grid Solar
                        and Battery Solutions, Home Power Back Up, Solar
                        Installation, Solar Panels and Recreational Batteries.
                        Located in Milton, Ontario and we install anywhere.
                      </h2> */}
                      <p className="para_main">
                      Located in Milton, Ontario, we are solar, battery, inverter and electrical experts for residential, cottage, off-grid, commercial and outbuilding projects. We sell and install solar panels, roof and ground mounts, inverters, battery storage (ESS) and backup generators, from 1 kW to 180 kW, with a licensed master electrician on our own crew.
<br/>
<br/>
We are authorized installers for EG4, Canadian Solar EP Cube 2.0 and EcoFlow, and we carry the full range of Volthium LiFePO4 batteries for recreation, RV and marine use.
<br/>
<br/>
{/* Our TRU Shop is at <a href="https://www.google.com/maps/place/348+Bronte+St.+S+Unit+21,+Milton,+ON+L9T+5B6/@43.4996211,-79.8791121,17z/data=!3m1!4b1!4m6!3m5!1s0x882b6f83e20b0dbb:0x1a2e4d6ae194e01c!8m2!3d43.4996211!4d-79.8791121!16s%2Fg%2F11x5t7x8st?entry=ttu&g_ep=EgoyMDI2MDYyOC4wIKXMDSoASAFQAw%3D%3D" target="_blank">348 Bronte St South #21</a> in Milton, Ontario. Our general number is <a href="tel:9054626525">905-462-6525</a> */}
Visit us at 348 Bronte St South, Unit 21 in Milton, Ontario or call our main line: <a href="tel:9054626525">905-462-6525</a>
<br/>
<br/>
For solar, inverters and batteries, please call Jacob Collier at <a href="tel:6479149699">647-914-9699</a> or <a href="mailto:jacob@truoffgrid.com">jacob@truoffgrid.com</a>. For TRU Electrical Services, please call Steve Monteleone at <a href="tel:2899817825">289-981-7825</a> or <a href="mailto:steve@truelectric.ca">steve@truelectric.ca</a>. We are open Monday to Friday, 9 am to 5 pm.
                       
                      </p>
                      <Link style={{ textDecoration: "none" }} to="/shop">
                        <button className={`${styles.button1} button_main`}>
                          Shop Now{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16.988"
                            height="19.02"
                            viewBox="0 0 16.988 19.02"
                            fill="#fff"
                          >
                            <g id="bag" transform="translate(0.801 0.8)">
                              <path
                                id="Path_4188"
                                data-name="Path 4188"
                                d="M5.456,13.6A1.742,1.742,0,0,1,7.193,12H17.7a1.742,1.742,0,0,1,1.737,1.6l.7,8.71A1.742,1.742,0,0,1,18.4,24.194H6.493a1.742,1.742,0,0,1-1.736-1.881Z"
                                transform="translate(-4.751 -6.774)"
                                fill="none"
                                stroke="#fff"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.6"
                              />
                              <path
                                id="Path_4189"
                                data-name="Path 4189"
                                d="M18.968,10.839V6.484A3.484,3.484,0,0,0,15.484,3h0A3.484,3.484,0,0,0,12,6.484v4.355"
                                transform="translate(-7.791 -3)"
                                fill="none"
                                stroke="#fff"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.6"
                              />
                            </g>
                          </svg>
                        </button>
                      </Link>
                    </div>
                  </Col>
                  <Col lg={5}>
                    <div className={styles.imgCol}>
                      <img
                        alt="side "
                        className={styles.backgroundImage}
                        // onClick={()=>{navigate("/shop/TRU-Off-Grid-Promotions-and-Package-Deals")}}
                        onClick={()=>{navigate("/shop")}}
                        // src="/images/hero1.png"
                        src="/images/home-hero-slide-1.jpg"
                      />
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>
              <SwiperSlide>
                <Row lg={12} className="w-100 gy-5">
                  <Col lg={7}>
                    <div className={styles.contentCont}>
                      <h2 className="h1_main">EG4 HOME BATTERY BACKUP
</h2>
                      <p className="para_main">
                       Whole-home and critical-load backup with EG4 hybrid inverters, the GridBOSS and 14.3 kWh LiFePO4 batteries with a 10-year warranty. Designed, permitted and installed by our own crew.</p>
                      <Link style={{ textDecoration: "none" }} to="/solar-installation">
                        <button className={`${styles.button1} button_main`}>
                          Learn More
                        </button>
                      </Link>
                    </div>
                  </Col>
                  <Col lg={5}>
                    <div className={styles.imgCol}>
                      <img
                        alt="side "
                        onClick={()=>{navigate("/solar-installation")}}
                        className={styles.backgroundImage}
                        src="/images/home-hero-slide-2.jpg"
                      />
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>
              <SwiperSlide>
                <Row lg={12} className="w-100 gy-5">
                  <Col lg={7}>
                    <div className={styles.contentCont}>
                      <h2 className="h1_main">
                        EP CUBE 2.0 BY CANADIAN SOLAR
                      </h2>
                      <p className="para_main">
                       A sleek all-in-one battery and hybrid inverter, 5 to 40 kWh per unit, with automatic whole-home backup and a 10-year warranty. Pair it with new rooftop solar for up to $10,000 in Ontario rebates.  
                      </p>
                      <Link style={{ textDecoration: "none" }} to="/solar-installation">
                        <button className={`${styles.button1} button_main`}>
                          Learn More
                        </button>
                      </Link>
                    </div>
                  </Col>
                  <Col lg={5}>
                    <div className={styles.imgCol}>
                      <img
                        alt="side "
                        className={styles.backgroundImage}
                        onClick={()=>{navigate("/solar-installation")}}
                        src="/images/home-hero-slide-3.jpg"
                      />
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>

                 <SwiperSlide>
                <Row lg={12} className="w-100 gy-5">
                  <Col lg={7}>
                    <div className={styles.contentCont}>
                      <h2 className="h1_main">
                       OFF-GRID COTTAGES, CABINS AND SHOPS
                      </h2>
                      <p className="para_main">
                     EG4 off-grid systems sized to how you use your property: solar, batteries and an automatic backup generator, built for Ontario winters.  
                      </p>
                      <Link style={{ textDecoration: "none" }} to="/blogs/eg4-6000xp-vs-12000xp-off-grid-cottage">
                        <button className={`${styles.button1} button_main`}>
                          Learn More
                        </button>
                      </Link>
                    </div>
                  </Col>
                  <Col lg={5}>
                    <div className={styles.imgCol}>
                      <img
                        alt="side "
                        className={styles.backgroundImage}
                        onClick={()=>{navigate("/blogs/eg4-6000xp-vs-12000xp-off-grid-cottage")}}
                        src="/images/home-hero-slide-4.jpg"
                      />
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>

                 <SwiperSlide>
                <Row lg={12} className="w-100 gy-5">
                  <Col lg={7}>
                    <div className={styles.contentCont}>
                      <h2 className="h1_main">
                       COMMERCIAL SITE POWER
                      </h2>
                      <p className="para_main">
                     Solar, batteries and automatic backup generators for site offices, scale houses and job trailers, built into a sea container at our Milton shop. Rent it or own it.
                      </p>
                      <Link style={{ textDecoration: "none" }} to="/commercial-solar-installation">
                        <button className={`${styles.button1} button_main`}>
                          Learn More
                        </button>
                      </Link>
                    </div>
                  </Col>
                  <Col lg={5}>
                    <div className={styles.imgCol}>
                      <img
                        alt="side "
                        className={styles.backgroundImage}
                        onClick={()=>{navigate("/commercial-solar-installation")}}
                        src="/images/home-hero-slide-5.jpg"
                      />
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>

                 <SwiperSlide>
                <Row lg={12} className="w-100 gy-5">
                  <Col lg={7}>
                    <div className={styles.contentCont}>
                      <h2 className="h1_main">
                        ECOFLOW PORTABLE AND BACKUP POWER
                      </h2>
                      <p className="para_main">
                     {/* Solar, batteries and automatic backup generators for site offices, scale houses and job trailers, built into a sea container at our Milton shop. Rent it or own it. */}
                     EcoFlow power stations and critical-load backup for homes, cottages and RVs, in stock at our Milton shop.
                      </p>
                      <Link style={{ textDecoration: "none" }} to="/shop/EcoFlow-Home-Back-Up">
                        <button className={`${styles.button1} button_main`}>
                          Shop Now
                        </button>
                      </Link>
                    </div>
                  </Col>
                  <Col lg={5}>
                    <div className={styles.imgCol}>
                      <img
                        alt="side "
                        className={styles.backgroundImage}
                        onClick={()=>{navigate("/shop/EcoFlow-Home-Back-Up")}}
                        src="/images/home-hero-slide-6.jpg"
                      />
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>

            </Swiper>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Hero;
